export const buildSearchContextRequest = (search) => {
    const querySearchParams = (search === null || search === void 0 ? void 0 : search.get("search")) || "";
    if (!querySearchParams)
        return undefined;
    const params = new URLSearchParams(querySearchParams);
    const getParam = (key) => params.get(key) || (search === null || search === void 0 ? void 0 : search.get(key)) || "";
    const distributionTypes = getParam("distributionTypes");
    const estateTypes = getParam("estateTypes");
    const locations = getParam("locations");
    if (!distributionTypes || !estateTypes || !locations)
        return undefined;
    const searchParamContext = {
        distributionTypes,
        estateTypes,
        locations,
    };
    const priceMax = getParam("priceMax");
    const priceMin = getParam("priceMin");
    if (priceMax)
        searchParamContext.priceMax = priceMax;
    if (priceMin)
        searchParamContext.priceMin = priceMin;
    return searchParamContext;
};
